import { SelectValue } from "antd/lib/select";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import useFetchWrapper, { HttpResponse } from "../../../Helpers/useFetchWrapper";
import { Props, Rating, RatingsResponse, TabStatus,  User } from "./RatingsTab.model";
import moment from "moment";

export const pageSize = 10;

export const useRatingsTab = ({ filters }: Props) => {
	const [admins, setAdmins] = useState<User[]>();
	const [ratings, setRatings] = useState<Rating[]>();
	const [ratingsPagination, setRatingsPagination] = useState({ page: 1, size: pageSize, total: 0 });
	const [tabStatus, setTabStatus] = useState<TabStatus>(TabStatus.Loading);
	const intl = useIntl();

	const { get, put } = useFetchWrapper();

	useEffect(() => {
		getRatings();
		getAdmins();
	}, [ratingsPagination.page]);

	useEffect(() => {

		if (ratingsPagination.page > 1) {
			setRatingsPagination({ ...ratingsPagination, page: 1, })
		} else {
			getRatings();
		}
	}, [ filters ]);


	const assignRating = async (value: SelectValue, rating: Rating) => {
		const response = await put(`/review/rating-assign/${rating.user.userId}/${rating.userRated.userId}`, { userId: value });
		if (response.status === 200) getRatings();
	}

	const reassignRating = async (value: SelectValue, rating: Rating) => {
		const response = await put(`/review/rating-reassign/${rating.user.userId}/${rating.userRated.userId}`, { userId: value });
		if (response.status === 200) getRatings();
	}

	const formatDate = (date: string) => {
		return moment(date).format("DD MMM YYYY");
	}

	const getAdmins = async() => {
		const response: HttpResponse<any> = await get(`/user/admin?page=${1}&size=${100}`);
		if (response.parsedBody) {
			const { users } = response.parsedBody;
			setAdmins(users);
		}
	}

	const getRatings = async () => {
		setTabStatus(TabStatus.Loading);
		const activefilters = filters?.includes('myRatingsOnly') ? filters : `${filters}&myRatingsOnly=false`;
		const response: HttpResponse<RatingsResponse> = await get(`/review/rating?page=${ratingsPagination.page}&size=${ratingsPagination.size}&${activefilters}`);
		if (response.parsedBody) {
			const { ratings, count } = response.parsedBody;
			setRatings(ratings);
			setRatingsPagination({ ...ratingsPagination, total: count });
			setTabStatus(TabStatus.Loaded);
		}
		else {
			setTabStatus(TabStatus.Error);
		}
	}

	const isAssignedAdminDeleted = (adminId: string) => {
		return !admins?.find(admin => admin.userId === adminId);
	}

	const onChangeRatingsPagination = (page: number) => {
		setRatingsPagination({ ...ratingsPagination, page });
	}

	return {
		assignRating,
		formatDate,
		getRatings,
		isAssignedAdminDeleted,
		onChangeRatingsPagination,
		reassignRating,
		state: { admins, ratings, ratingsPagination, tabStatus }
	}
}